module.exports = __webpack_public_path__ + "static/media/img180.9a8da4e5.jpg";